import React, { useMemo } from 'react';
import { capitalize } from 'lodash';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

import GenericDetails from 'partial/components/GenericDetails';
import { useActiveAccount } from 'modules/auth/hooks';
import Button from 'partial/components/Button';

import { useSelectedTransaction } from '../hooks';

const STATUS_CLASS = {
  SUCCESS: 'text-secondary-800',
  PENDING: 'text-yellow-500',
};

function ViewTransaction() {
  const history = useHistory();
  const location = useLocation();
  const { uuid } = useParams();
  const [activeAccount] = useActiveAccount();
  const [isLoading, transaction] = useSelectedTransaction({
    id: uuid,
  });
  const initData = useMemo(() => location.state || transaction, [
    location,
    transaction,
  ]);
  const renderFormat = useMemo(() => {
    const cols = [
      {
        label: 'Date',
        key: 'created_at',
      },
      {
        label: 'Client Ref. NO.',
        key: 'client_refno',
      },
      {
        label: 'Ref. NO.',
        key: 'refno',
      },
      {
        label: 'Order ID',
        key: 'order_id',
      },
      {
        label: 'Amount',
        key: 'amount_human',
      },
      {
        label: 'Transaction Fee',
        key: 'transaction_fee_human',
      },
      {
        label: 'Other Charges',
        key: 'other_charges_human',
      },
      {
        label: 'Net Amount',
        key: 'net_amount_human',
      },
      {
        label: 'Cashback Amount',
        key: 'cashback_amount_human',
      },
      {
        label: 'Account Number',
        key: 'account_number',
      },
      {
        label: 'Account Name',
        key: 'account_name',
      },
      {
        label: 'Email',
        key: 'account_email',
      },
      {
        label: 'Payment Status',
        key: (row) => (
          <span className={`${STATUS_CLASS[row?.payment_status]}`}>
            {capitalize(row?.payment_status)}
          </span>
        ),
      },
    ];
    if (transaction?.request && transaction?.request?.length > 0) {
      transaction?.request.forEach((item) => {
        cols.push({
          label: item?.label,
          key: () =>
            item?.type === 'AMOUNT' ? `B$${item?.value}` : item?.value,
        });
      });
    }
    if (activeAccount?.role === 'organization') {
      cols.splice(2, 0, {
        label: 'Biller Name',
        key: 'biller_name',
      });
    }
    return cols;
  }, [activeAccount, transaction]);

  return (
    <div>
      <div>
        <Button
          icon={FaArrowLeft}
          onClick={() => history.push('/transactions')}
        >
          Back
        </Button>
      </div>
      <div className="p-5 border-b text-lg font-medium">
        {initData?.client_refno}
      </div>
      <div className="p-5 mt-5">
        <GenericDetails
          data={initData}
          format={renderFormat}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}

export default ViewTransaction;
